import React from 'react';
import './styles/SunFlower.css';

const SunFlower = ({ className }) => {
  return (
    <div className={`sunflower-decor ${className || ''}`} aria-hidden="true">
      🌻
    </div>
  );
};

export default SunFlower;
